export enum TypeDeleteFile {
  UNIQUE = 1,
  MASIVE = 2,
}

export enum TypeFileEnum {
    PDF= 1,
    WORD= 2,
    CSV= 3,
    EXCEL= 4,
    POWERPOINT= 5,
    TXT= 6,
    IMAGE= 7,
    VIDEO= 8,
}

export enum TypeFileTextEnum {
    PDF= 'PDF',
    WORD= 'WORD',
    CSV= 'CSV',
    EXCEL= 'EXCEL',
    POWERPOINT= 'POWERPOINT',
    TXT= 'TXT',
    IMAGE= 'IMAGE',
    VIDEO= 'VIDEO',
}